var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.type === 'EY Podcasts')?_c('div',{staticClass:"h-auto w-full"},[_c('Podcast',{attrs:{"data":_vm.data}})],1):_c('div',{staticClass:"h-auto w-ful"},[_c('Comm',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }